import { useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import { useRegister } from "../hooks/useAuth"
import { Eye, EyeOff } from "lucide-react"

export default function Register() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [username, setUsername] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState("")
  const navigate = useNavigate()
  const registerMutation = useRegister()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")

    try {
      await registerMutation.mutateAsync({
        email,
        password,
        username,
      })

      navigate("/login", {
        state: {
          message: "Registration successful! Please login with your credentials."
        }
      })
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed")
    }
  }

  return (
      <div className="relative min-h-screen flex items-center justify-end p-4 xl:pr-64 lg:pr-14 overflow-hidden">
 
  <video
    className="absolute top-0 left-0 w-full h-full object-cover"
    src="/images/login-bg.mp4" 
    autoPlay
    loop
    muted
    playsInline
  />

  <div className="absolute inset-0 bg-black/40"></div>

 
  <div className="relative z-10 auth-card">
    <div className="text-center mb-8">
      <h1 className="text-xl lg:text-4xl font-bold mb-2">
        <span className="text-accent">CREATE ACCOUNT</span>
      </h1>
      <p className="text-text-secondary">Join the Minati Verse</p>
    </div>

    {error && <div className="error-message">{error}</div>}

    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Username */}
      <div>
        <label className="form-label">Username</label>
        <input
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          className="form-input"
          placeholder="Choose a username"
        />
      </div>

      {/* Email */}
      <div>
        <label className="form-label">Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="form-input"
          placeholder="your.email@example.com"
        />
      </div>

      {/* Password with eye toggle */}
      <div>
        <label className="form-label">Password</label>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="form-input pr-10"
            placeholder="••••••••"
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        disabled={registerMutation.isLoading}
        className="btn-primary text-center justify-center w-full disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {registerMutation.isLoading ? "Creating Account..." : "Register"}
      </button>
    </form>

    <p className="mt-6 text-center text-text-secondary">
      Already have an account?{" "}
      <Link
        to="/login"
        className="text-accent-cyan hover:text-accent-bright-cyan font-semibold"
      >
        Login
      </Link>
    </p>
  </div>
</div>

  )
}
